import { NumberOrNull } from 'store/entity/types';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ISearchFolderObject {
  loading: boolean;
  folderId: NumberOrNull;
}

type IThemeMode = 'dark' | 'light';

export interface IAppStates {
  searchInFolder: ISearchFolderObject;
  UI: {
    sidebar: {
      isSideBarCollapsed: boolean;
    };
    themeMode: IThemeMode;
    webdaThemeMode: IThemeMode;
  };
}

export function isMobile() {
  return window.innerWidth < 600;
}

const getSideBarStatusFromLocalStorage = (): boolean => {
  let isSideBarCollapsed = localStorage.getItem('isSideBarCollapsed');
  if (!isSideBarCollapsed) {
    isSideBarCollapsed = isMobile() ? 'true' : 'false';
  }
  return isSideBarCollapsed === 'true';
};

const initialState: IAppStates = {
  searchInFolder: {
    loading: false,
    folderId: null,
  },
  UI: {
    sidebar: {
      isSideBarCollapsed: getSideBarStatusFromLocalStorage(),
    },
    themeMode: 'light',
    webdaThemeMode: 'dark',
  },
};

function updateSearchInFolderIdHandler(
  state: IAppStates,
  action: PayloadAction<{ folderId: number | null }>
) {
  state.searchInFolder.folderId = action.payload.folderId;
}
function searchInFolderStartedHandler(state: IAppStates) {
  state.searchInFolder.loading = true;
}
function changeStateOFSideBarHandler(
  state: IAppStates,
  action: PayloadAction<{ isCollapsed: boolean }>
) {
  state.UI.sidebar.isSideBarCollapsed = action.payload.isCollapsed;
}
function setSearchItemsHandler(state: IAppStates) {
  state.searchInFolder.loading = false;
}
function changeThemeModeHandler(
  state: IAppStates,
  action: PayloadAction<Partial<Omit<IAppStates['UI'], 'sidebar'>>>
) {
  if (action.payload.themeMode) {
    state.UI.themeMode = action.payload.themeMode;
  } else if (action.payload.webdaThemeMode) {
    state.UI.webdaThemeMode = action.payload.webdaThemeMode;
  }
}

const appSlice = createSlice({
  name: 'app',
  initialState: initialState,
  reducers: {
    updateSearchInFolderId: updateSearchInFolderIdHandler,
    searchInFolderStarted: searchInFolderStartedHandler,
    changeStateOFSideBar: changeStateOFSideBarHandler,
    setSearchItems: setSearchItemsHandler,
    changeThemeMode: changeThemeModeHandler,
  },
});

export const {
  updateSearchInFolderId,
  searchInFolderStarted,
  changeStateOFSideBar,
  setSearchItems,
  changeThemeMode,
} = appSlice.actions;

export default appSlice.reducer;
